import FaqSection from "@/components/sections/products/shared/faq";
import { MOBILE_PRODUCT_FAQS } from "./data";

export default function MobileProductFaq() {
  return (
    <FaqSection
      faqs={MOBILE_PRODUCT_FAQS}
      description="Everything you need to know about Proxidize mobile proxies. Can't find what you're looking for?"
      headingId="mobile-product-faq-heading"
      contactVariant="button"
    />
  );
}
